export enum RiskAppetiteType {
    NotSet = 0,
    InLine = 1,
    NotInLine = 2
}